import Logo from "@/components/brand/Logo";

// Full-screen branded loader shown during Suspense / auth gating.
// Replaces the bare "Cargando..." text so the app feels polished during cold start.
export default function PageLoader() {
    return (
        <div
            className="min-h-screen bg-bone flex flex-col items-center justify-center gap-6"
            data-testid="page-loader"
        >
            <Logo size="md" />
            <div className="flex gap-1.5" aria-label="Cargando">
                {[0, 1, 2].map((i) => (
                    <span
                        key={i}
                        className="w-1.5 h-1.5 rounded-full bg-petrol/40 qc-dot-bounce"
                        style={{ animationDelay: `${i * 0.15}s` }}
                    />
                ))}
            </div>
        </div>
    );
}
